export default "__VITE_ASSET__DXDtLKEy__"